export default {
  path: 'fund',
  meta: {
    title: '资金管理'
  },
  component: () => import('@/components/parent-view'),
  name: 'om-fund',
  children: [
    {
      path: 'bank',
      meta: {
        title: '开户信息'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'account',
          name: 'omFundBankAccount',
          meta: {
            title: '开户信息',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/fund/account')
        },
        {
          path: 'account/:code',
          name: 'omFundrBankAccountDetail',
          meta: {
            title: '账号信息'
          },
          component: () => import('@/view/fund/account/detail.vue')
        }
      ]
    },
    {
      path: 'amount',
      meta: {
        title: '资金账户'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'account',
          name: 'cacheOmFundAmountAccount',
          meta: {
            title: '资金账户',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/fund/moneyAccount')
        },
        {
          path: 'recharge',
          name: 'omFundAmountRecharge',
          meta: {
            title: '充值'
          },
          component: () => import('@/view/fund/moneyAccount/recharge')
        },
        {
          path: 'withdraw',
          name: 'omFundAmountWithdraw',
          meta: {
            title: '提现'
          },
          component: () => import('@/view/fund/moneyAccount/withdraw')
        }
      ]
    },
    {
      path: 'tran/details',
      name: 'cache-om-fund-transaction-details',
      meta: {
        title: '交易明细'
      },
      component: () => import('@/view/fund/transaction')
    },
    {
      path: 'replace/open/account',
      name: 'omFundReplaceOpenAccount',
      meta: {
        title: '代客开户'
      },
      component: () => import('@/view/fund/replace-open-account')
    },
    {
      path: 'replace/pay/wechat',
      name: 'omFundReplacePayWechat',
      meta: {
        title: '微信支付'
      },
      component: () => import('@/view/fund/wechatTransaction')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/fund.js